import styled from 'styled-components'
import Card from '../../../components/Card'

export const Container = styled.div`
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 16px 64px 16px;
`

type CardItemType = {
  numOfCardsInEachLine: number
}

export const CardItem = styled(Card)<CardItemType>`
  min-height: 100px;
  min-width: 100px;
  max-width: calc(
    (100% / ${({ numOfCardsInEachLine }): number => numOfCardsInEachLine}) -
      16px
  );
  aspect-ratio: 58/89;
  font-size: 8rem;
  flex: 1 0
    calc(
      (100% / ${({ numOfCardsInEachLine }): number => numOfCardsInEachLine}) -
        16px
    );
`

type CardDivType = {
  isFound: boolean
  // cardIndex: number
}

export const CardDiv = styled.div<{
  isFound: boolean
  cardIndex: number
  cardCaption: string
}>`
  width: 100%;
  position: relative;
  aspect-ratio: 58/89;
  padding-top: 30px;
  &::after {
    visibility: ${({ isFound }) => (isFound ? 'visible' : 'hidden')};
    //content: '${(props) => props.cardIndex} pair';
    content: '${(props) => props.cardCaption} ';
    font-size: medium;
    font-family: system-ui;
    text-align: center;
    padding-top: 100%;
    color: hotpink;
    width: 100%;
    height: inherit;
    // aspect-ratio: 58/89;
    border-radius: 10px;
    background: rgba(169, 169, 169, 0.2);
    position: absolute;
    top: calc(30px + 10%);
    left: 0;
  }
`
export const CardImg = styled.img`
  max-width: 100%;
  border-radius: 10px;
  position: relative;
`

export const CardFounded = styled.div`
  content: 'found!';
  width: 100%;
  height: 100%;
  background: rgba(128, 128, 255, 0.1);
  position: absolute;
  top: 0;
  left: 0;
`
